import Vue from 'vue'
import VueCookies from 'vue-cookies'

Vue.use(VueCookies, { expires: '7d'})

export default Vue.$cookies;
